
<ValidationProvider
  v-slot="validationContext"
  :name="content.libAireTexte"
  :rules="'required' + (content.maxCaractere ? `|max:${content.maxCaractere}` : '')"
  class="w-100"
  tag="div"
>
  <b-form-group>
    <label :for="content.inputNameAireTexte ? content.inputNameAireTexte : 'aireTexte'">
      {{ content.libAireTexte }}
    </label>
    <textarea
      :id="'aire-texte-' + uid"
      v-model="aireTexte"
      class="aire-texte w-100 mb-n1"
      :name="content.inputNameAireTexte ? content.inputNameAireTexte : 'aireTexte'"
      :rows="content.nbLignes"
      :state="getValidationState(validationContext)"
    />
    <div class="d-inline-flex w-100">
      <ErreurValidation
        id="aire-texte-live-feedback"
        :message="validationContext.errors[0]"
        :variables="variablesARemplacer"
      />
      <div v-if="content.maxCaractere" class="max-caracteres">
        <span>
          {{ getTexteCaractereRestant() }}
        </span>
      </div>
    </div>
  </b-form-group>
</ValidationProvider>
